// Matches exactly `/blog` (any query string — `?page=`, `?tag=` — is not part
// of urlPathname). `precedence: 100` wins over the CMS catch-all
// `@category/@page` Route Function (precedence 0) for this path (Vike
// resolvePrecedence: positive-precedence Route Functions sort first).
export function route(pageContext: { urlPathname: string }) {
  const path = pageContext.urlPathname.replace(/\/+$/, "") || "/";
  if (path === "/blog") {
    return { routeParams: {}, precedence: 100 };
  }
  return false;
}
